import { InternLocation } from '../intern/location';
import { ContentIntro } from './intro';

/**
 * Model definition for Maps
 */

export interface ContentMap {
  __component: 'content.map';
  id: number;
  intro?: ContentIntro;
  locations?: InternLocation[];
}

export function isContentMap(obj: { __component?: string }): obj is ContentMap {
  return obj.__component === 'content.map';
}
